<template>
<v-app>
  <div v-if="summary">
          <card shadow type="secondary">
               <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">Application Summary</h3>
                                </div>
                            </div>
                        </div>
                <template>
                                <div class="pl-lg-4">
                                    <!-- <div class="firstInstructions" style="text-transform: uppercase;margin-left: 40px;margin-bottom: 10px">
                                        <h3 style="text-decoration: underline">members loan application and loan agreement form</h3>
                                        <h3>this loan application must be fully completed in duplicate.<br> incomplete applications will neither be accepted or considered.</h3>
                                    </div> -->
                                    <div class="partA" style="margin-left: 40px;margin-bottom: 10px">
                                        <h3 style="text-decoration: underline;text-transform: uppercase">part a</h3>
                                        <div class="row">
                                            <div class="col-6">I <span class="writings">  {{specificMember.data.member_lastname}}, {{specificMember.data.member_firstname}}</span></div>
                                            <div class="col-6">Member No <span class="writings"> {{specificMember.data.member_id}}</span></div>
                                        </div>
                                        <p>ID No. <span class="writings">{{specificMember.data.id_no}}</span></p>
                                        <div class="row">
                                            <div class="col-6">Address <span class="writings">{{specificMember.data.address}}</span></div>
                                            <div class="col-6">Tel <span class="writings">{{specificMember.data.telephone}}</span></div>
                                        </div>
                                        <p>Hereby request a loan of Ksh(figures) <span class="writings">{{formatCost(loanAmountFigure)}}</span></p>
                                        <!-- <p>(in words) <span class="writings">{{loanAmountWord}}</span> Kenyan shillings</p> -->
                                        <p>To be repaid in monthly installements of Ksh(figures) <span class="writings">{{formatCost(monthlyInstallementsFigure)}}</span></p>
                                        <!-- <p>(in words) <span class="writings">{{monthlyInstallementsWord}} </span> Kenyan Shillings</p> -->
                                        <!-- <p>No. of installements <span class="writings">{{noOfInstallements}} </span></p> -->
                                        <p>The purpose of this loan is <span class="writings">{{purpose}}</span></p>
                                        <!-- <div class="agreement" style="text-transform: uppercase">
                                            <h3>name in full <span class="writings upper">{{specificMember.data.member_lastname}} {{specificMember.data.member_firstname}} </span></h3>
                                            <div class="row">
                                                <div class="col-6"><h3>signed</h3></div>
                                                <div class="col-6"><h3>date <span class="writings upper"> </span></h3></div>
                                            </div>
                                        </div> -->
                                    </div><hr>
                                    <div class="partB" style="margin-left: 40px;margin-bottom: 10px">
                                        <h3 style="text-decoration: underline;text-transform: uppercase">part b</h3>
                                        <h4><em>(Repayment Guarantee)</em></h4>

                                        <div style="margin-top: 10px">
                                            <div class="row">
                                                <div class="col-6">1) Name <span class="writings">{{guarantor1.member_names}} </span></div>
                                                <div class="col-6">Member No <span class="writings">{{guarantor1.member_id}} </span></div>
                                            </div>
                                            <!-- <p>Amount Guranteed <span class="writings">{{formatCost(amountGuaranteed1)}} </span></p> -->
                                            <!-- <p>Guarantor total shares <span class="writings">{{formatCost(guarantor1.member_shares)}} </span></p>
                                            <p>Other loan(s) & amount guaranteed <span class="writings">{{formatCost(otherLoanGuanteed1)}} </span></p> -->
                                            <!-- <div class="row">
                                                <div class="col-6">Signed</div>
                                                <div class="col-6">Date <span class="writings"> </span></div>
                                            </div> -->
                                        </div><hr>
                                        <div style="margin-top: 10px">
                                            <div class="row">
                                                <div class="col-6">2) Name <span class="writings">{{guarantor2.member_names}} </span></div>
                                                <div class="col-6">Member No <span class="writings">{{guarantor2.member_id}} </span></div>
                                            </div>
                                            <!-- <p>Amount Guranteed <span class="writings">{{formatCost(amountGuaranteed2)}} </span></p> -->
                                            <!-- <p>Guarantor total shares <span class="writings">{{formatCost(guarantor2.member_shares)}} </span></p>
                                            <p>Other loan(s) & amount guaranteed <span class="writings">{{formatCost(otherLoanGuanteed2)}} </span></p> -->
                                            <!-- <div class="row">
                                                <div class="col-6">Signed</div>
                                                <div class="col-6">Date <span class="writings"></span></div>
                                            </div> -->
                                        </div>
                                    </div>
                                </div>
                    <div class="row" justify="space-between">
                        <div class="col-lg-6">
                            <v-btn color="primary" @click="back">
                                Back
                            </v-btn>
                        </div>
                        <div class="col-lg-6" v-if="loaderStatus">
                            <loader></loader>
                        </div>
                        <div class="col-lg-6" v-else>
                            <v-btn color="primary" @click="submit">
                                Submit
                            </v-btn>
                        </div>
                    </div>
                </template>
             </card>

     </div>
     <div v-else>

 <v-stepper v-model="e1" :alt-labels="altLabels">

      <v-stepper-header>
        <v-stepper-step
            :complete="e1 > 1"
            step="1"
            :editable="editable">Personal Information</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
            :complete="e1 > 2"
            step="2"
            :editable="editable">Guarantors</v-stepper-step>

      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
         <card shadow type="secondary">
               <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">My account</h3>
                                </div>
                            </div>
                        </div>
                <template>
                            <form @submit.prevent>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Loan Amount (Figures)"
                                                        placeholder="Eg. 3,000,000"
                                                        input-classes="form-control-alternative"
                                                        v-model="loanAmountFigure"
                                            />
                                            <p class="message" v-if="!$v.loanAmountFigure.required"> * Loan Amount Figures detail is required</p>
                                        </div>
                                    </div>
                                    <!-- <div class="row">
                                        <div class="col-md-12">
                                            <base-input alternative=""
                                                        label="Loan Amount (Words)"
                                                        placeholder="Eg. Three million "
                                                        input-classes="form-control-alternative"
                                                        v-model="loanAmountWord"
                                            />
                                            <p class="message" v-if="!$v.loanAmountWord.required"> * Loan Amount Words detail is required</p>
                                        </div>
                                    </div> -->
                                    <div class="row">
                                        <!-- <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Number of Installments"
                                                        placeholder="Eg. 18"
                                                        input-classes="form-control-alternative"
                                                        v-model="noOfInstallements"
                                            />
                                            <p class="message" v-if="!$v.noOfInstallements.required"> * No of Installements detail is required</p>
                                        </div> -->
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Monthly Installments Payment (Figures)"
                                                        placeholder="Eg. 20,000"
                                                        input-classes="form-control-alternative"
                                                        v-model="monthlyInstallementsFigure"
                                            />
                                            <p class="message" v-if="!$v.monthlyInstallementsFigure.required"> * Monthly Installements Figures detail is required</p>
                                        </div>
                                    </div>
                                    <!-- <div class="row">
                                        <div class="col-md-12">
                                            <base-input alternative=""
                                                        label="Monthly Installments Payment (Words)"
                                                        placeholder="Eg. Twenty Thousand"
                                                        input-classes="form-control-alternative"
                                                        v-model="monthlyInstallementsWord"
                                            />
                                            <p class="message" v-if="!$v.monthlyInstallementsWord.required"> * Monthly Installements Words detail is required</p>
                                        </div>
                                    </div> -->
                                    <div class="form-group">
                                        <base-input alternative=""
                                                    label="Loan Purpose">
                                            <textarea rows="4" class="form-control form-control-alternative" placeholder="The purpose of the loan is ..." v-model="purpose"></textarea>
                                            <p class="message" v-if="!$v.purpose.required"> * Loan Purpose detail is required</p>
                                        </base-input>
                                    </div>
                                </div>
                            </form>
                        </template>
             </card>
  <br>
          <v-btn
            color="primary"
            @click="e1 = 2"
          >
            Continue
          </v-btn>

          <v-btn text>Cancel</v-btn>
        </v-stepper-content>

        <v-stepper-content step="2">
            <card shadow type="secondary">
                <div slot="header" class="bg-white border-0">
                    <div class="row align-items-center">
                        <div class="col-8">
                            <h3 class="mb-0">My Guarantors</h3>
                        </div>
                    </div>
                </div>
                <template>
                        <h6 class="heading-small text-muted mb-4">Guarantor 1</h6>
                        <div class="pl-lg-4">
                            <div class="row">
                                <div class="col-lg-6">
                                    <label  class="form-control-label" input-classes="form-control-alternative">
                                        Guarantor Name
                                    </label>
                                    <model-list-select :list="allMembers"
                                                       v-model="guarantor1"
                                                       option-value="user_public_id"
                                                       option-text="member_names"
                                                       placeholder="select item">
                                    </model-list-select>
                                    <p class="message" v-if="!$v.guarantor1.required"> * Guarantor 1 detail is required</p>
                                </div>
                                <!-- <div class="col-lg-6">
                                    <base-input alternative=""
                                                label="Amount Guaranteed"
                                                placeholder="Eg. Ksh 3,000,000"
                                                input-classes="form-control-alternative"
                                                v-model="amountGuaranteed1"
                                    />
                                    <p class="message" v-if="!$v.amountGuaranteed1.required"> * Amount Guaranteed detail is required</p>
                                </div> -->
                            </div>
                            <!-- <div class="row">
                                <div class="col-md-12">
                                    <base-input alternative=""
                                                label="Other loans guaranteed"
                                                placeholder="Eg. Twenty Thousand"
                                                input-classes="form-control-alternative"
                                                v-model="otherLoanGuanteed1"
                                    />
                                    <p class="message" v-if="!$v.otherLoanGuanteed1.required"> * Other Guaranteed detail is required</p>
                                </div>
                            </div> -->
                        </div>
                        <hr class="my-4" />
                        <h6 class="heading-small text-muted mb-4">Guarantor 2</h6>
                        <div class="pl-lg-4">
                            <div class="row">
                                <div class="col-lg-6">
                                    <label  class="form-control-label" input-classes="form-control-alternative">
                                        Guarantor Name
                                    </label>
                                    <model-list-select :list="allMembers"
                                                       v-model="guarantor2"
                                                       option-value="user_public_id"
                                                       option-text="member_names"
                                                       placeholder="select item">
                                    </model-list-select>
                                    <p class="message" v-if="!$v.guarantor2.required"> * Guarantor 2 detail is required</p>
                                </div>
                                <!-- <div class="col-lg-6">
                                    <base-input alternative=""
                                                label="Amount Guaranteed"
                                                placeholder="Eg. Ksh 3,000,000"
                                                input-classes="form-control-alternative"
                                                v-model="amountGuaranteed2"
                                    />
                                    <p class="message" v-if="!$v.amountGuaranteed2.required"> * Amount Guaranteed detail is required</p>
                                </div> -->
                            </div>
                            <!-- <div class="row">
                                <div class="col-md-12">
                                    <base-input alternative=""
                                                label="Other loans guaranteed"
                                                placeholder="Eg. Twenty Thousand"
                                                input-classes="form-control-alternative"
                                                v-model="otherLoanGuanteed2"
                                    />
                                    <p class="message" v-if="!$v.otherLoanGuanteed2.required"> * Other Guaranteed detail is required</p>
                                </div>
                            </div> -->
                        </div>
                        <hr class="my-4" />

                </template>
            </card>
            <br>

          <v-btn
            color="primary"
            @click="summaryStart"
          >
            Finish
          </v-btn>

          <v-btn text>Cancel</v-btn>
        </v-stepper-content>


      </v-stepper-items>
    </v-stepper>
       </div>
</v-app>
</template>
<script>
    import Vue from 'vue';
    import Loader from "../../components/Loader"
    import { ModelListSelect } from 'vue-search-select'
    import 'vue-search-select/dist/VueSearchSelect.css'
    const { required} = require('vuelidate/lib/validators');
    var converter = require('number-to-words');
export default {
    name: 'applicationFormStepper',
    data () {
    return {
      e1: 0,
      altLabels: true,
      editable: true,
      summary: false,
            loanAmountWord: '',
            loanAmountFigure: '',
            noOfInstallements: '',
            monthlyInstallementsWord: '',
            monthlyInstallementsFigure: '',
            guarantor1: {},
            amountGuaranteed1: '20000',
            otherLoanGuanteed1: 'None',
            guarantor2: {},
            amountGuaranteed2: '20000',
            otherLoanGuanteed2: 'None',
            purpose: '',
    }
  },
    components: {
        ModelListSelect,
        Loader
    },
    validations: {
        loanAmountFigure: {
            required
        },
        monthlyInstallementsFigure: {
            required
        },
        guarantor1: {
            required
        },
        guarantor2: {
            required
        },
        purpose: {
            required
        },
    },
    created() {
        const userPublicId = localStorage.getItem('pdis');
        this.$store.dispatch('viewspecificMember_function', userPublicId);
        this.$store.dispatch('viewallMembers_function');
    },
    watch: {
        no_installements(){
            this.noOfInstallements = this.loanAmountFigure / this.monthlyInstallementsFigure
        },
    },
  methods: {
        summaryStart(){
           this.summary = true;
        },
      back(){
          this.summary = false;
      },
      formatCost(amount) {
         const result = Number(amount).toLocaleString()
          if (result !== 0) {
              return `Ksh. ${result}`;
          } else {
              return '0';
          }
      },
      findInstallments(loan, monthly){
          const noLoan = parseInt(loan, 10);
          const noMonthly = parseInt(monthly, 10);
          return Math.floor(noLoan/noMonthly);
      },
      submit(){
          const details = {
              loan_amount_words: converter.toWords(this.loanAmountFigure),
              loan_amount_figures: this.loanAmountFigure,
              no_of_installements: this.findInstallments(this.loanAmountFigure, this.monthlyInstallementsFigure),
              monthly_installements_words: converter.toWords(this.monthlyInstallementsFigure),
              monthly_installements_figures: this.monthlyInstallementsFigure,
              user_public_id1: this.guarantor1.user_public_id,
              amount_guaranteed1: this.amountGuaranteed1,
              other_loans_guaranteed1: this.otherLoanGuanteed1,
              user_public_id2: this.guarantor2.user_public_id,
              amount_guaranteed2: this.amountGuaranteed2,
              other_loans_guaranteed2: this.otherLoanGuanteed2,
              loan_purpose: this.purpose
      };
            console.log("Loan data", details);
          if (this.$v.$invalid) {
              Vue.notify({ title: 'Error', text: 'There is a validation error', type: 'warn' });
          } else {
              this.$store.dispatch('loanapplication_function', details)
          }
      }
  },
}
</script>
<style scoped>
.formBorder{
    font-size: .875rem;
    display: block;
    margin: 1rem 0;
    padding: .75rem;
    color: #393f49;
    border-radius: .25rem;
    background-color: #fff;
    box-shadow: rgba(0,0,0,.1) 0 0 0 1px,rgba(0,0,0,.1) 0 4px 16px;
}
.writings{
    color: darkblue;
    padding-left: 30px;
    padding-right: 5px;
}
.upper{
    text-transform: uppercase;
}
.message{
    color: #f57f6c;
    font-size: 0.75rem;
    margin-left: 24px;
    margin-top: 0.3rem;
}
</style>
